import type { RouteObject } from 'react-router-dom'
import { ROUTES } from '@/config/routes.config'
import { lazyRouteComponent } from '@/shared/routing/lazy-route-component'
const LoginPage = lazyRouteComponent('LoginPage', () => import('./login'))
const SimulatedLoginPage = lazyRouteComponent('SimulatedLoginPage', () => import('./simulated-login'))
const PasswordSetupPage = lazyRouteComponent('PasswordSetupPage', () => import('./password-setup'))
const RegisterPage = lazyRouteComponent('RegisterPage', () => import('@/features/admission/pages/RegisterPage'))
const CompanySelectionPage = lazyRouteComponent('CompanySelectionPage', () => import('@/features/admission/pages/CompanySelectionPage'))
const AdmissionWorkspacePage = lazyRouteComponent('AdmissionWorkspacePage', () => import('@/features/admission/pages/AdmissionWorkspacePage'))
const AdmissionWorkspaceLayout = lazyRouteComponent('AdmissionWorkspaceLayout', () => import('@/features/admission/components/AdmissionWorkspaceLayout'))
const EnterpriseProfileEditPage = lazyRouteComponent('EnterpriseProfileEditPage', () => import('@/features/admission/pages/EnterpriseProfileEditPage'))

export const authRoutes: RouteObject[] = [
  {
    path: ROUTES.login,
    element: <LoginPage />,
    handle: { tab: false, title: '登录' },
  },
  {
    path: '/simulated-login',
    element: <SimulatedLoginPage />,
    handle: { tab: false, title: '登录中' },
  },
  {
    path: ROUTES.passwordSetup,
    element: <PasswordSetupPage />,
    handle: { tab: false, title: '设置新密码' },
  },
  {
    path: ROUTES.register,
    element: <RegisterPage />,
    handle: { tab: false, title: '注册供应商' },
  },
  {
    path: ROUTES.admissionCompanies,
    element: <CompanySelectionPage />,
    handle: { tab: false, title: '进入供应商申请' },
  },
  {
    path: ROUTES.admissionWorkspace,
    element: <AdmissionWorkspaceLayout><AdmissionWorkspacePage /></AdmissionWorkspaceLayout>,
    handle: { tab: false, title: '供应商准入工作台' },
  },
  {
    path: ROUTES.admissionProfileEdit,
    element: <AdmissionWorkspaceLayout><EnterpriseProfileEditPage /></AdmissionWorkspaceLayout>,
    handle: { tab: false, title: '企业资料维护' },
  },
]
